import * as yup from 'yup'

export const collectionSchema = yup.object({
    name: yup
        .string()
        .required('Collection Name is required')
          .min(3, 'Collection Name must be at least 3 characters')
        .max(25, 'Collection Name cannot exceed 25 characters'),

    shortDescription: yup
        .string()
        .required('Short Description is required')
        .max(75, 'Short Description cannot exceed 75 characters'),

    longDescription: yup
        .string()
        .nullable(),
    labels: yup
        .array()
        .of(yup.string())
        .min(1, 'At least one label is required')
        .required(),
    icon: yup
        .mixed()
        .required('Icon is required')
        .test(
            'file-or-string',
            'Icon must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),
    thumbnail: yup
        .mixed()
        .required('Thumbnail is required')
        .test(
            'file-or-string',
            'Icon must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),
    cardImage1: yup
        .mixed()
        .required('Card Image 1 is required')
        .test(
            'file-or-string',
            'Icon must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),
    cardImage2: yup
        .mixed()
        .required('Card Image 2 is required')
        .test(
            'file-or-string',
            'Icon must be a file or a valid string',
            (value) => {
                if (!value) return false;

                // String case (URL / filename / base64)
                if (typeof value === 'string') {
                    return value.trim().length > 0;
                }

                // File case
                if (value instanceof File) {
                    return true;
                }

                return false;
            }
        ),

})
